import type { ComponentType } from 'react';
import FoldersHeader from './FoldersHeader';
import FoldersHeaderContainer, { OwnProps } from './FoldersHeader.container';

export default FoldersHeaderContainer(
  FoldersHeader
) as ComponentType<OwnProps>;
